import { useDispatch, useSelector } from 'react-redux'
import {
    useClearCartMutation,
    useGetCartInfoQuery,
    useGetCountProductsQuery,
} from '@/shared/api-rtk/api-list/cartApi'
import { useMemo } from 'react'
import { reset } from '@/shared/store/slice/cartSlice'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { useGetCartItemsQuery } from '@/shared/api-rtk'

function removeHtmlTags(input) {
    return input.replace(/<[^>]*>/g, '')
}

export const StatisticCart = ({ totals, userInfo }) => {
    const dispatch = useDispatch()

    const data = (function () {
        const data = []
        for (let i = 0; i < totals.length; i++) {
            let copy = { ...totals[i] }
            copy['title'] = removeHtmlTags(totals[i]['title'])
            data.push(copy)
        }
        return data
    })()

    const { cartLoading: isLoading } = useSelector((state) => state.cartActions)

    const { refetch } = useGetCartInfoQuery()
    const { refetch: refetchProductsInCart } = useGetCartItemsQuery()
    const { refetch: refetchCount } = useGetCountProductsQuery()
    const [clearCart] = useClearCartMutation()
    const handleClearCart = () => {
        if (window.confirm('Вы действительно хотите очистить корзину?')) {
            clearCart(userInfo)
            refetch()
            refetchProductsInCart()
            refetchCount()
            dispatch(reset())
        }
    }

    return (
        <div className={'StatisticCart'}>
            <div className={'card-statistic'}>
                <h3>Ваш заказ</h3>
                {data.map((item, index) => (
                    <div key={item.title}>
                        {isLoading && <Skeleton height={28} />}
                        {!isLoading && (
                            <div className={'card-row'}>
                                <h4>{item.title}</h4>
                                <h2>{item.text}</h2>
                            </div>
                        )}
                        {totals.length !== index + 1 && (
                            <div className={'rect'} />
                        )}
                    </div>
                ))}
            </div>
            <button onClick={handleClearCart} className={'clear-cart-action'}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                >
                    <path
                        d="M1.33203 3.85449H14.6654M2.9987 3.85449H12.9987V15.5212C12.9987 15.9814 12.6256 16.3545 12.1654 16.3545H3.83203C3.37179 16.3545 2.9987 15.9814 2.9987 15.5212V3.85449ZM5.4987 1.35449H10.4987C10.9589 1.35449 11.332 1.72759 11.332 2.18783V3.85449H4.66536V2.18783C4.66536 1.72759 5.03846 1.35449 5.4987 1.35449Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                Очистить корзину
            </button>
        </div>
    )
}
